import React, { useState, useEffect } from 'react';
import { MessageSquare } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api';
import ChatEngine from './ChatEngine';

/**
 * Chat Button Component - Shows unread count and opens chat
 * Can be placed in any navbar
 */
const ChatButton = ({ className = '' }) => {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Fetch unread count
  useEffect(() => {
    if (!user?.userId) return;

    const fetchUnreadCount = async () => {
      try {
        const response = await api.get(`/chat/unread-count?userId=${user.userId}`);
        setUnreadCount(response.data.unreadCount || 0);
      } catch (error) {
        // Error handled silently
      }
    };

    fetchUnreadCount();

    // Poll for updates every 30 seconds
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, [user?.userId]);

  return (
    <>
      <button
        onClick={() => setIsChatOpen(true)}
        className={`relative p-2 hover:bg-collaborb-spherical-mid rounded-full transition-colors ${className}`}
        title="Messages"
      >
        <MessageSquare className="w-5 h-5" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      <ChatEngine
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
      />
    </>
  );
};

export default ChatButton;

